import { render, staticRenderFns } from "./ParentTuteur.vue?vue&type=template&id=222aae28&scoped=true"
import script from "./ParentTuteur.vue?vue&type=script&lang=js"
export * from "./ParentTuteur.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=222aae28&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222aae28",
  null
  
)

export default component.exports